// extracted by css-extract-rspack-plugin
export default {"Box":"label-module__Box__wCSI_","StateLabel":"label-module__StateLabel__qI_dr","Text":"label-module__Text__gKwkA"};